const budgetCommentsEndpoints = {
  list: (companyId: string) => `/companies/${companyId}/reporting/financial-statement/comments` as const,
  detail: (companyId: string, commentId: number) => `/companies/${companyId}/budgeting/comments/${commentId}` as const,
  create: (companyId: string) => `/companies/${companyId}/budgeting/comments/` as const
}

export default budgetCommentsEndpoints
